import { ReactNode } from "react";
import {
  AltRoute,
  LocalShipping,
  Route,
  ViewModule,
} from "@mui/icons-material";
import type { Assignment } from "./EquipmentDropdown.types";

export const assignmentTypeToIconMap: Record<
  NonNullable<Assignment>["type"],
  ReactNode
> = {
  Route: <Route />,
  Trap: <ViewModule />,
  Trip: <LocalShipping />,
  Lane: <AltRoute />,
};
